import React, { useEffect } from 'react';
import formatCurrency from '../../func/currency_formatter';

const CardHalfEach = ({
	handleCardClick,
	styles,
	labels,
	data,
	displayBadges,
	priceLayout,
	showTotal,
	outOfStock,
	modifyFont,
	setModifyFont,
}) => {
	let totalPrice = data.formatted_total_amount
		? data.formatted_total_amount
		: formatCurrency(Number(data?.price) * Number(data?.amount));
	let oldPrice = data?.formatted_old_price ? data?.formatted_old_price : formatCurrency(Number(data?.old_price));
	let currentPrice = data?.formatted_price ? data?.formatted_price : formatCurrency(Number(data?.price));

	if (outOfStock) {
		totalPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, Number(1 * data.amount).toFixed(2))
			: formatCurrency(Number(1.0 * data.amount));
		oldPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, '1.00')
			: formatCurrency(Number(1));
		currentPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, '1.00')
			: formatCurrency(Number(1));
	}

	useEffect(() => {
		if (
			(data.formatted_old_price && data.formatted_old_price.length > 8) ||
			(data.formatted_old_price && data.formatted_old_price.length > 8) ||
			(data.formatted_old_price && data.formatted_price.length > 8)
		) {
			setModifyFont(true);
		}
	}, []);

	return (
		<div className="productsColumns__item" style={styles?.card} onClick={handleCardClick}>
			<div className="productsColumns__itemHeading productsColumns__itemHeading--active" style={styles?.heading}>
				{outOfStock ? 'Out Of Stock' : data.status}
			</div>
			<div className="productsColumns__itemContentWrap">
				<div className="image__wrapper--alt">
					<img
						src={data.image.url}
						alt="product x4"
						style={{ height: '100%', width: 'auto' }}
						className="mon-img-176-h"
					/>
				</div>
				{displayBadges && !outOfStock && (
					<div className="productsRows__itemPerks productsRows__itemPerks--active productsRows__itemPerks--package  only-mobile-badges">
						<div style={styles?.shippingBadge}>{labels?.shipping}</div>
						<div style={styles.savingsBadge}>
							{labels?.saveLabel} -{data.you_save_percentage}%
						</div>
					</div>
				)}
				<div className="itemEachContent">
					<div className="itemEachContent__itemNumber" style={styles?.primaryColor}>
						{data.amount}x
					</div>
					<div className="itemEachContent__itemName" style={styles?.primaryColor}>
						{data.display_name}
					</div>
					<div
						className={
							modifyFont
								? 'itemEachContent__itemEach itemEachContent__itemEach--long'
								: 'itemEachContent__itemEach'
						}
					>
						<div style={styles?.priceColor}>{currentPrice}</div>
						<div style={styles?.secondaryColor}>{labels?.eachLabel}</div>
					</div>
					{showTotal && (
						<div className="itemEachContent__itemTotal" style={priceLayout?.oldPricePosition}>
							<div style={{ ...styles?.totalColor, textDecolration: 'none' }}>
								{labels?.totalLabel}: {totalPrice}
							</div>
							<s style={{ ...styles?.secondaryColor, ...priceLayout?.totalPosition }}>{oldPrice}</s>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default CardHalfEach;
